import React from 'react';
import { volumes } from '../data/volumes';
import { SectionLabel } from './ui/SectionLabel';
export function LibrarySection() {
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-20" aria-labelledby="library-heading" data-id="element-70" data-mp="23cai30lpl8x6">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-71" data-mp="2hbs8tlikew96">
        <div className="mx-auto max-w-2xl text-center" data-id="element-72" data-mp="2daq44p5vprzt">
          <div className="flex justify-center" data-id="element-73" data-mp="2d95endyf8z8t">
            <SectionLabel data-id="element-74" data-mp="1pmgpq8azw6ip">The library</SectionLabel>
          </div>
          <h2 id="library-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-75" data-mp="1kmknadhy4n59">
            120 Ready-to-Teach classes.
            <span className="block text-forest" data-id="element-76" data-mp="1tmh7a1te4xtz">One professional library.</span>
          </h2>
        </div>

        <ul className="mt-7 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3" data-id="element-77" data-mp="15wmv7mgwbdas">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col rounded-2xl border border-sandDark bg-ivory p-2.5 text-center sm:p-4" data-id="element-78" data-mp="11v1ko7ru3b3r">
              <img src={volume.cover} alt={`Volume ${volume.number}: ${volume.title}`} className="w-full rounded-lg" width={900} height={1200} loading="lazy" data-id="element-79" data-mp="12f69a7cdcm4k" />
              <p className="mt-2.5 text-[0.58rem] font-semibold uppercase tracking-label text-gold" data-id="element-80" data-mp="ei0kamip795n">
                Volume {volume.number}
              </p>
              <h3 className="mt-1 font-serif text-[0.85rem] font-semibold uppercase leading-tight text-ink sm:text-base" data-id="element-81" data-mp="jhlpheogodqt">
                {volume.title}
              </h3>
              <p className="mt-auto pt-2 text-[0.55rem] font-semibold uppercase tracking-label text-forest sm:text-[0.62rem]" data-id="element-82" data-mp="tgazkla48twi">
                20 Classes
              </p>
            </li>)}
        </ul>

        <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-gold/30 bg-ivory px-5 py-3 text-center text-[0.62rem] font-semibold uppercase tracking-label text-muted sm:text-xs" data-id="element-83" data-mp="24t3ntm3p707t">
          <span data-id="element-84" data-mp="3w0kpol8eylbt">6 Volumes</span>
          <span className="text-gold" aria-hidden="true" data-id="element-85" data-mp="dtdfif8tb49j">
            ×
          </span>
          <span data-id="element-86" data-mp="9rjh6dm3accj">20 Classes</span>
          <span className="text-gold" aria-hidden="true" data-id="element-87" data-mp="9sbfhw72mo6i">
            =
          </span>
          <span className="text-forest" data-id="element-88" data-mp="3i6a9wteea1hw">120 Ready-to-Teach Classes</span>
        </p>
      </div>
    </section>;
}